import getCurrentUrl from './utils/getCurrentUrl';
import buildAuthorizationUrl from './utils/buildAuthorizationUrl';
const getLoginUrl = (authServerConfig, clientConfig, loginParameters) => {
    return buildAuthorizationUrl(Object.assign({ responseType: 'none', redirectUri: loginParameters.redirectUri || getCurrentUrl(window.location.href), state: loginParameters.state }, clientConfig), authServerConfig);
};
export { getLoginUrl };
//# sourceMappingURL=getLoginUrl.js.map